import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class InvitationService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.INVITATION = '/api/invitation';

        this.GET_LIST_FOR_USER = '/list/user/{userId}';
        this.GET_SENT_LIST_BY_USER_ID = '/list/sent/user/{userId}';
        this.CREATE_FORM_AGENT_INVITATION = '/create';
        this.ADD_USER = '/add-user';
        this.ACCEPT = '/accept';
        this.DENY = '/deny';
    }

    /**
     * This class manages the REST Protocols for Invitations.
     *
     * GET Invitations:
     *     1) getInvitationListForUser - GET By User ID
     *     2) getSentInvitationListForUser - GET By User ID
     *
     * POST Invitations:
     *     1) acceptInvitation - Accept Invitation
     *     2) denyInvitation - Deny Invitation
     *     3) createInvitation - CREATE Invitation
     */

    async getInvitationListForUser(userId) {
        try {
            let url = window.location.origin + this.INVITATION + this.GET_LIST_FOR_USER;
            url = url
                .replace('{userId}', userId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getSentInvitationListForUser(userId) {
        try {
            let url = window.location.origin + this.INVITATION + this.GET_SENT_LIST_BY_USER_ID;
            url = url
                .replace('{userId}', userId);
            const sentInvitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return sentInvitations;
        } catch (err) {
            console.log(err);
        }
    }

    async acceptInvitation(invitation) {
        try {
            let url = window.location.origin + this.INVITATION + this.ACCEPT;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(invitation)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async addUserDirectly(invitation) {
        try {
            let url = window.location.origin + this.INVITATION + this.ADD_USER;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(invitation)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async denyInvitation(invitation) {
        try {
            let url = window.location.origin + this.INVITATION + this.DENY;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(invitation)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async createInvitation(invitation){
        try{
            let url = window.location.origin + this.INVITATION;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const invitationCreated = this.fetch(url, {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(invitation)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return invitationCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async createFormAgentInvitation(invitation){
        try{
            let url = window.location.origin + this.INVITATION + this.CREATE_FORM_AGENT_INVITATION;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const invitationCreated = this.fetch(url, {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(invitation)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return invitationCreated;
        }
        catch(err){
            console.log(err);
        }
    }
}

export default InvitationService;
